export const STATISTIC_TYPE_DEMOGRAPHY = 'demography-v13';
export const STATISTIC_TYPE_BOOKING_ORIGIN = 'booking-origin-v24';
export const STATISTIC_TYPE_SELF_SERVICE = 'self-service-v2';
export const STATISTIC_TYPE_CALL_CENTER = 'call-center-v12';
export const STATISTIC_TYPE_VOUCHER = 'voucher-v1';
export const STATISTIC_TYPE_RESOURCE_VOUCHER = 'resource-voucher-v2';
export const STATISTIC_TYPE_DISCOUNT_CODE = 'discount-code-v1';
export const STATISTIC_TYPE_COMPETITOR_AVAILABILITY = 'competitor-availability-v1';
export const STATISTIC_TYPE_BON_REVENUE = 'bon-revenue-v1';
export const STATISTIC_TYPE_BON_STATS = 'bon-stats-v1';
export const STATISTIC_TYPE_BON_ANALYSIS = 'bon-analysis-v1';
export const STATISTIC_TYPE_UPGRADE = 'upgrade-v4';
export const STATISTIC_TYPE_AGENT_SESSION = 'agent-session-v1';
export const STATISTIC_TYPE_CUSTOMER_JOURNEY = 'customer-journey-v2';
export const STATISTIC_TYPE_CUSTOMER_LIFETIME_VALUE = 'customer-lifetime-value-v1';
export const STATISTIC_TYPE_MARKETING_COSTS = 'marketing-costs-v1';
export const STATISTIC_TYPE_COPAGO_COMPLIANCE = 'copago-compliance-v2';
// v3 restricts the statistic to Arenaleitung and Kundenbetreuung (role-checked, not just the
// Timebutler department) and scopes its published wage table to those two roles.
export const STATISTIC_TYPE_STAFF_COST = 'staff-cost-v3';
export const STATISTIC_TYPE_AREA_STAFF_COST = 'area-staff-cost-v3';
export const STATISTIC_TYPE_B2B = 'b2b-v3';
export const STATISTIC_TYPE_COMPLAINTS = 'complaints-v1';
